// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo-module__logoContainer_bqgPf","logo":"Logo-module__logo_OgepE","logoImage":"Logo-module__logoImage_u8fdK","logoText":"Logo-module__logoText_ROQhp"};